import React, { useState, useEffect } from 'react';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

import {
  FaBolt,
  FaUsers,
  FaRocket,
  FaShieldAlt,
  FaCalendarAlt,
  FaHeart,
  FaLeaf,
  FaArrowRight,
  FaTint,
  FaShoppingCart
} from 'react-icons/fa';

import '../styles/AboutPage.css';
import reanimeitorBanner from '../Assets/banner-reanimeitor.jpg';

const AboutPage = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // STATS REALES (sin inventos)
  const statsData = [
    {
      value: '2025',
      label: 'Fundación',
      icon: <FaCalendarAlt />,
      color: '#ffcc00',
      description: 'Nace reanimeitor'
    },
    {
      value: '2.4K+',
      label: 'Clientes',
      icon: <FaUsers />,
      color: '#60a5fa',
      description: 'Confían en nuestra energía'
    },
    {
      value: '51/30/11.5',
      label: 'Kcal · Cafeína · Azúcar',
      icon: <FaBolt />,
      color: '#10b981',
      description: 'por 100ml'
    }
  ];

  // VALORES centrados en la bebida
  const valuesData = [
    {
      icon: <FaBolt />,
      title: 'Energía Real',
      description: 'Fórmula equilibrada con cafeína (30mg/100ml) y el justo aporte calórico (51kcal/100ml).',
      color: '#ffcc00',
      gradient: 'linear-gradient(135deg, #ffcc00, #ff9900)',
      points: [
        'Cafeína controlada',
        'Efecto sostenido',
        'Sin bloqueantes artificiales'
      ]
    },
    {
      icon: <FaTint />,
      title: 'Sabor Único',
      description: 'Intenso, refrescante y pensado para paladares exigentes. Azúcares 11.5g/100ml.',
      color: '#60a5fa',
      gradient: 'linear-gradient(135deg, #60a5fa, #3b82f6)',
      points: [
        'Perfil frutal exclusivo',
        'Toque cítrico',
        'Final limpio'
      ]
    },
    {
      icon: <FaUsers />,
      title: 'Comunidad',
      description: 'Miles de personas ya han cambiado su forma de tomar energía. Únete.',
      color: '#10b981',
      gradient: 'linear-gradient(135deg, #10b981, #059669)',
      points: [
        '+2400 clientes',
        'Valoraciones 4.98★',
        'Recomendación boca a boca'
      ]
    }
  ];

  // EQUIPO (sin cambios, solo quitamos referencias a blockchain)
  const teamMembers = [
    {
      photo: require('../Assets/sergio.png'),
      initials: 'SP',
      name: 'Sergio Pérez Hidalgo',
      role: 'Fundador & CEO',
      bio: 'Emprendedor apasionado por las bebidas energéticas de calidad. Creador de la fórmula única de reanimeitor.',
      color: '#ffcc00',
      fullName: 'Sergio Pérez Hidalgo'
    },
    {
      photo: require('../Assets/daniel.png'),
      initials: 'DF',
      name: 'Daniel Fuentes Espuis',
      role: 'Ingeniero de Producto',
      bio: 'Responsable del desarrollo de la fórmula y la cadena de suministro. Garantiza la calidad en cada lata.',
      color: '#60a5fa',
      fullName: 'Daniel Fuentes Espuis'
    },
    {
      photo: require('../Assets/joseluis.png'),
      initials: 'JF',
      name: 'Jose Luis Fuentes Sánchez',
      role: 'Director de Operaciones',
      bio: 'Optimiza la logística y producción para que cada lata llegue en perfectas condiciones.',
      color: '#10b981',
      fullName: 'Jose Luis Fuentes Sánchez'
    }
  ];

  // HITOS (solo hechos reales)
  const milestones = [
    {
      year: '2025',
      title: 'Fundación',
      description: 'Nace reanimeitor con la misión de ofrecer una bebida energética diferente, transparente y efectiva.',
      icon: '🚀',
      completed: true,
      details: 'Tras meses de investigación, se desarrolla la primera fórmula.'
    },
    {
      year: '2026',
      title: 'Lanzamiento Oficial',
      description: 'Salida al mercado de los packs 24 y 48 latas con envío a toda España.',
      icon: '⚡',
      completed: false,
      details: 'Próximamente disponibles en nuestra web.'
    }
  ];

  return (
    <div className="about-page">

      {/* EFECTOS ELÉCTRICOS DE FONDO */}
      <div className="energy-field">
        <div className="energy-bolt"></div>
        <div className="energy-bolt"></div>
        <div className="energy-bolt"></div>
        <div className="energy-bolt"></div>
        <div className="energy-bolt"></div>
        <div className="energy-node"></div>
        <div className="energy-node"></div>
        <div className="energy-node"></div>
        <div className="energy-node"></div>
        <div className="energy-wave"></div>
      </div>

      {/* HERO */}
      <section className="about-hero">
        <div className="hero-content">
          <div className="hero-badge">
            <span className="badge-icon">⚡</span>
            <span className="badge-text">DESDE 2025</span>
          </div>
          <h1 className="hero-title">
            <span className="title-line">Sobre</span>
            <span className="title-line-gradient">Nosotros</span>
          </h1>
          <p className="hero-description">
            Reanimeitor nace para darte la energía que necesitas, con transparencia y el mejor sabor.
          </p>
          <div className="hero-tags">
            <span className="hero-tag">Energía real</span>
            <span className="hero-tag">51 kcal/100ml</span>
            <span className="hero-tag">Cafeína 30mg</span>
            <span className="hero-tag">Envío 24h</span>
          </div>
        </div>
      </section>

      {/* STATS */}
      <section className="about-stats-section">
        <div className="stats-container">
          <div className="section-header-mini">
            <h2>Datos que importan</h2>
            <div className="header-line-small"></div>
          </div>
          {isMobile ? (
            <Swiper
              modules={[Pagination, Autoplay]}
              spaceBetween={16}
              slidesPerView={1.2}
              centeredSlides={true}
              pagination={{ clickable: true, dynamicBullets: true }}
              autoplay={{ delay: 3000, disableOnInteraction: false }}
              loop
              className="stats-carousel"
            >
              {statsData.map((stat, idx) => (
                <SwiperSlide key={idx}>
                  <div className="stat-card-mobile">
                    <div className="stat-icon-wrapper" style={{ color: stat.color }}>{stat.icon}</div>
                    <div className="stat-value">{stat.value}</div>
                    <div className="stat-label">{stat.label}</div>
                    <div className="stat-description">{stat.description}</div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          ) : (
            <div className="stats-grid">
              {statsData.map((stat, idx) => (
                <div key={idx} className="stat-card">
                  <div className="stat-icon-wrapper" style={{ color: stat.color }}>{stat.icon}</div>
                  <div className="stat-value">{stat.value}</div>
                  <div className="stat-label">{stat.label}</div>
                  <div className="stat-description">{stat.description}</div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* MISIÓN */}
      <section className="mission-section">
        <div className="mission-content">
          <div className="mission-text">
            <div className="section-header-left">
              <h2>Nuestra Misión</h2>
              <div className="header-line-left"></div>
            </div>
            <p className="mission-highlight">
              La energía que necesitas, sin engaños.
            </p>
            <p className="mission-description">
              En reanimeitor creemos que una bebida energética debe ser transparente:
              sabes exactamente qué tomas y qué efecto tiene. Por eso publicamos abiertamente
              nuestros valores nutricionales y fabricamos con ingredientes de calidad.
            </p>
            <div className="mission-quote">
              <span className="quote-icon">"</span>
              <p>51 kcal, 30mg cafeína, 11.5g azúcar por 100ml. Nada más, nada menos.</p>
            </div>
            <div className="mission-features">
              <div className="mission-feature">
                <FaBolt className="feature-icon" style={{ color: '#ffcc00' }} />
                <span>Energía real</span>
              </div>
              <div className="mission-feature">
                <FaTint className="feature-icon" style={{ color: '#60a5fa' }} />
                <span>Sabor único</span>
              </div>
              <div className="mission-feature">
                <FaShoppingCart className="feature-icon" style={{ color: '#10b981' }} />
                <span>Envío a domicilio</span>
              </div>
            </div>
          </div>
          <div className="mission-image">
            <div className="image-wrapper">
              <div className="image-glow"></div>
              <img src={reanimeitorBanner} alt="Misión reanimeitor" className="mission-img" />
              <div className="image-badge">
                <span>+2.400 clientes</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* VALORES */}
      <section className="values-section">
        <div className="section-header">
          <h2>Nuestros Valores</h2>
          <div className="header-line"></div>
          <p className="section-subheader">Lo que nos mueve cada día</p>
        </div>
        {isMobile ? (
          <div className="values-carousel-container">
            <Swiper
              modules={[Pagination, Autoplay]}
              spaceBetween={16}
              slidesPerView={1}
              pagination={{ clickable: true, dynamicBullets: true }}
              autoplay={{ delay: 4000, disableOnInteraction: false }}
              loop
              className="values-carousel"
            >
              {valuesData.map((val, idx) => (
                <SwiperSlide key={idx}>
                  <div className="value-card-premium">
                    <div className="value-card-header" style={{ background: val.gradient + '20' }}>
                      <div className="value-icon-large" style={{ color: val.color }}>{val.icon}</div>
                      <h3 style={{ color: val.color }}>{val.title}</h3>
                    </div>
                    <div className="value-card-body">
                      <p className="value-description">{val.description}</p>
                      <div className="value-points">
                        {val.points.map((point, i) => (
                          <div key={i} className="value-point">
                            <span className="point-dot" style={{ background: val.color }}></span>
                            <span>{point}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        ) : (
          <div className="values-grid-premium">
            {valuesData.map((val, idx) => (
              <div key={idx} className="value-card-premium">
                <div className="value-card-header" style={{ background: val.gradient + '15' }}>
                  <div className="value-icon-large" style={{ color: val.color }}>{val.icon}</div>
                  <h3 style={{ color: val.color }}>{val.title}</h3>
                </div>
                <div className="value-card-body">
                  <p className="value-description">{val.description}</p>
                  <div className="value-points">
                    {val.points.map((point, i) => (
                      <div key={i} className="value-point">
                        <span className="point-dot" style={{ background: val.color }}></span>
                        <span>{point}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </section>

      {/* HITOS */}
      <section className="milestones-section">
        <div className="section-header">
          <h2>Nuestro Camino</h2>
          <div className="header-line"></div>
        </div>
        <div className="milestones-container">
          {isMobile ? (
            <Swiper
              modules={[Pagination, Autoplay]}
              spaceBetween={16}
              slidesPerView={1}
              pagination={{ clickable: true, dynamicBullets: true }}
              autoplay={{ delay: 4000, disableOnInteraction: false }}
              loop
              className="milestones-carousel"
            >
              {milestones.map((m, idx) => (
                <SwiperSlide key={idx}>
                  <div className={`milestone-card-mobile ${m.completed ? 'completed' : 'upcoming'}`}>
                    <div className="milestone-icon" style={{ borderColor: m.completed ? '#ffcc00' : '#10b981', color: m.completed ? '#ffcc00' : '#10b981' }}>{m.icon}</div>
                    <span className="milestone-year">{m.year}</span>
                    <h3>{m.title}</h3>
                    <p>{m.description}</p>
                    <div className="milestone-details"><p>{m.details}</p></div>
                    <span className="milestone-badge">{m.completed ? '✓ COMPLETADO' : '⚡ PRÓXIMAMENTE'}</span>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          ) : (
            <div className="milestones-grid">
              {milestones.map((m, idx) => (
                <div key={idx} className={`milestone-card ${m.completed ? 'completed' : 'upcoming'}`}>
                  <div className="milestone-icon" style={{ borderColor: m.completed ? '#ffcc00' : '#10b981', color: m.completed ? '#ffcc00' : '#10b981' }}>{m.icon}</div>
                  <span className="milestone-year">{m.year}</span>
                  <h3>{m.title}</h3>
                  <p>{m.description}</p>
                  <div className="milestone-details"><p>{m.details}</p></div>
                  <span className="milestone-badge">{m.completed ? '✓ COMPLETADO' : '⚡ PRÓXIMAMENTE'}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* EQUIPO */}
      <section className="team-section">
        <div className="section-header">
          <h2>Nuestro Equipo</h2>
          <div className="header-line"></div>
          <p className="section-subheader">Los que hacen posible cada lata</p>
        </div>
        {isMobile ? (
          <div className="team-carousel-container">
            <Swiper
              modules={[Pagination, Autoplay]}
              spaceBetween={16}
              slidesPerView={1}
              pagination={{ clickable: true, dynamicBullets: true }}
              autoplay={{ delay: 4000, disableOnInteraction: false }}
              loop
              className="team-carousel"
            >
              {teamMembers.map((member, idx) => (
                <SwiperSlide key={idx}>
                  <div className="team-card-mobile">
                    <div className="member-avatar-premium">
                      <img src={member.photo} alt={member.name} className="member-photo" style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }} />
                    </div>
                    <h3 className="member-name">{member.name}</h3>
                    <div className="member-role" style={{ color: member.color }}>{member.role}</div>
                    <p className="member-bio">{member.bio}</p>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        ) : (
          <div className="team-grid-premium">
            {teamMembers.map((member, idx) => (
              <div key={idx} className="team-card-premium">
                <div className="team-card-header" style={{ background: `linear-gradient(135deg, ${member.color}20, transparent)` }}>
                  <div className="member-avatar-premium">
                    <img src={member.photo} alt={member.name} className="member-photo" style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }} />
                  </div>
                </div>
                <div className="team-card-body">
                  <h3 className="member-name">{member.name}</h3>
                  <div className="member-role" style={{ color: member.color }}>{member.role}</div>
                  <p className="member-bio">{member.bio}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </section>

      {/* CTA FINAL */}
      <section className="cta-section-premium">
        <div className="cta-content">
          <div className="cta-badge">
            <FaBolt className="cta-badge-icon" />
            <span>PRUEBA LA ENERGÍA REAL</span>
          </div>
          <h2>¿Listo para reactivarte?</h2>
          <p>Consigue tus packs de 24 o 48 latas con envío a toda España.</p>
          <div className="cta-buttons-premium">
            <button className="cta-btn-primary" onClick={() => window.location.href = '/'}>
              <span>Comprar ahora</span>
              <FaArrowRight className="btn-icon" />
            </button>
            <button className="cta-btn-secondary" onClick={() => window.location.href = '/account'}>
              <FaShoppingCart className="btn-icon" />
              <span>Mi cuenta</span>
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;